import { useState, useEffect } from 'react'
import { Outlet } from 'react-router-dom';
import useRefreshToken from '../../hooks/useRefreshToken';
import useAuth from '../../hooks/useAuth';
import Loader from '../Loader';

const PersistLogin = () => {
    const [isLoading, setIsLoading] = useState(true);
    const refresh = useRefreshToken();
    const { auth, persist, setAuth } = useAuth(); // Add setAuth to the destructure

    useEffect(() => {
        let isMounted = true;
        // console.log('persist', persist);
        const verifyRefreshToken = async () => {
            // console.log('verifying token', auth);
            try {
                const updatedCredentials = await refresh();
                // console.log('updatedCredentials', updatedCredentials);
                if (updatedCredentials) {
                    setAuth((prev: any) => ({
                        ...prev,
                        ...updatedCredentials,
                    }));
                }
            } catch (err) {
                console.error(err);
            } finally {
                isMounted && setIsLoading(false);
            }
        };

        !auth?.accessToken && persist ? verifyRefreshToken() : setIsLoading(false);
    }, []);

    // useEffect(() => {
    //     console.log(`isLoading: ${isLoading}`);
    //     console.log(`aT: ${JSON.stringify(auth?.accessToken)}`);
    // }, [isLoading]);

    return (
        <>
            {!persist ? (
                <Outlet />
            ) : isLoading ? (
                <Loader />
            ) : (
                <Outlet />
            )}
        </>
    );
};

export default PersistLogin;